import {
  Box,
  Header,
  SpaceBetween,
  Cards,
  Link,
  ColumnLayout,
  Pagination,
  CollectionPreferences,
  CollectionPreferencesProps,
  Table,
  Button,
  Modal,
} from '@cloudscape-design/components';

import { DashboardViewLayout } from '../../components/DashboardViewLayout';
import { useNavigate } from '@tanstack/react-router';
import {
  useUrlFilterState,
  useUrlRangeState,
  useUrlSortingState,
} from '../../common/filtering/filters';
import { useEffect, useMemo, useState } from 'react';
import { ContactTable } from '../../components/dashboard/ContactTable';
import { hideContacts, unhideContacts } from '../../common/api/contacts';
import { PlaceContact } from '../../common/types';

export default function View() {
  const navigate = useNavigate();
  const { query, setQuery } = useUrlFilterState();
  const [textQuery, setTextQuery] = useState('');
  // relative times are in the past vs future
  const past = true;
  const { sortingField, setSortingField, sortDirection, setSortDirection } = useUrlSortingState(
    'date',
    'desc',
  );
  const { range, setRange } = useUrlRangeState(past);
  const [now, setNow] = useState(new Date());
  const [selectedItems, setSelectedItems] = useState<PlaceContact[]>([]);

  const resourceName = 'Contacts';

  const showingHidden = query.tokens.filter((token) => token.propertyKey === 'hidden').length !== 0;

  return (
    <DashboardViewLayout breadcrumbs={[{ text: resourceName, href: '' }]} contentType="table">
      <ContactTable
        now={now}
        setNow={setNow}
        query={query}
        setQuery={setQuery}
        range={range}
        setRange={setRange}
        sortingField={sortingField}
        setSortingField={setSortingField}
        sortDirection={sortDirection}
        setSortDirection={setSortDirection}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        textQuery={textQuery}
        setTextQuery={setTextQuery}
        hideColumns={['department', 'mentions']}
        additionalActions={
          <SpaceBetween size="xs" direction="horizontal">
            {showingHidden ? (
              <Button
                variant="normal"
                iconName="undo"
                onClick={async () => {
                  await unhideContacts(selectedItems.map((item) => item.uuid));
                  setSelectedItems([]);
                  setQuery({
                    operation: query.operation,
                    tokens: query.tokens.filter((token) => token.propertyKey !== 'hidden'),
                  });
                  setNow(new Date(new Date().getTime() + 1000));
                }}
                disabled={selectedItems.length === 0}
              >
                Unhide
              </Button>
            ) : (
              <Button
                variant="normal"
                iconName="remove"
                onClick={async () => {
                  await hideContacts(selectedItems.map((item) => item.uuid));
                  setSelectedItems([]);
                  setNow(new Date(new Date().getTime() + 1000));
                }}
                disabled={selectedItems.length === 0}
              >
                Hide
              </Button>
            )}
          </SpaceBetween>
        }
      />
    </DashboardViewLayout>
  );
}
